class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tablist = this.querySelector("#tablist");
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
  }
  connectedCallback() {
    this.tabs.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.setSelectedTab(el);
        this.showActivePanel(el);
      });
    });
    this.tabs.forEach((el) => {
      el.addEventListener("keydown", (e) => {
        if ((e.keyCode || e.which) === 32) {
          this.setSelectedTab(el);
          this.showActivePanel(el);
          el.click();
        }
      });
    });

    if (this.tabs.length > 0) {
      this.tabs[0].ariaSelected = "true";
      this.panels[0].removeAttribute("hidden");
      this.createArrowNavigation();
      this.handleInitialState();
    }
  }

  createArrowNavigation() {
    const firstTab = this.tabs[0];
    const lastTab = this.tabs[this.tabs.length - 1];

    this.tabs.forEach((el) => {
      el.addEventListener("keydown", function (e) {
        if ((e.keyCode || e.which) === 38 || (e.keyCode || e.which) === 37) {
          if (el == firstTab) {
            e.preventDefault();
            lastTab.focus();
          } else {
            e.preventDefault();
            const focusableElement = this.tabs.indexOf(el) - 1;
            this.tabs[focusableElement].focus();
          }
        } else if ((e.keyCode || e.which) === 40 || (e.keyCode || e.which) === 39) {
          if (el == lastTab) {
            e.preventDefault();
            firstTab.focus();
          } else {
            e.preventDefault();
            const focusableElement = this.tabs.indexOf(el) + 1;
            this.tabs[focusableElement].focus();
          }
        }
      });
    });
  }

  handleInitialState() {
    this.tabs.forEach((e) => {
      e.setAttribute("tabindex", "0");
      e.ariaSelected = "false";
    });
    this.activateFirstPanel();
    this.determineTabIndex();
  }

  determineTabIndex() {
    this.panels.forEach((el) => {
      const focusableElements = this.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
      ).length;
      focusableElements ? el.setAttribute("tabindex", "0") : el.setAttribute("tabindex", "-1");
    });
  }

  activateFirstPanel() {
    this.tabs[0].setAttribute("tabindex", "0");
    this.tabs[0].ariaSelected = "true";
    this.panels[0].classList.add("visible");
  }

  setSelectedTab(el) {
    const selectedId = el.id;
    this.panels[0].classList.remove("visible");

    this.tabs.forEach((e) => {
      const id = e.getAttribute("id");
      if (id === selectedId) {
        e.setAttribute("aria-selected", "true");
      } else {
        e.setAttribute("aria-selected", "false");
      }
    });
  }

  showActivePanel(el) {
    const selectedId = el.id;
    this.panels.forEach((e) => {
      e.hidden = "true";
    });
    const activePanel = document.querySelector(`[aria-labelledby="${selectedId}"]`);
    activePanel.removeAttribute("hidden");
  }
}

customElements.define("product-tabs", ProductTabs);
